import { request } from '@/utils/http'
import { OperationType } from '@/enums/auth'
import { useAuthStore } from '@/stores/auth'

// ===================== 类型定义 =====================

export interface CheckDataOperationPermissionRequest {
  /** 业务表名，如 prc_inquiry_fcl */
  tableName: string
  /** 待操作记录 ID 列表 */
  ids: number[]
  /** 业务编号字段名，如 inquiry_no，用于越权提示 */
  codeField: string
  /** 操作类型 */
  operationType: OperationType
  /** 创建人 ID（用于前端短路：创建人 / 超管 直接放行，无需请求后端） */
  createdBy?: string
}

// ===================== API =====================

/**
 * 校验编辑/删除操作权限。
 *
 * 短路规则（不发请求，直接放行）：
 * - 当前登录用户是记录创建人
 * - 当前登录用户是超级管理员
 *
 * 越权时后端返回业务错误，HTTP 拦截器自动展示错误提示并 reject。
 */
export const checkDataOperationPermission = (data: CheckDataOperationPermissionRequest): Promise<void> => {
  const authStore = useAuthStore()
  const isCreator = data.createdBy !== undefined && data.createdBy === authStore.userInfo.id
  const isSuperAdmin = authStore.adminRole
  if (isCreator || isSuperAdmin) {
    return Promise.resolve()
  }
  return request.post('/sys/data-operation-permission/check', data)
}
